class FetchDocumentTypeSections {
	constructor(
		public readonly organizationId: number,
		public readonly documentTypeId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchDocumentTypeSections;
